import { DefaultState, Filters } from 'store/types';

export const SET_USERS_ACTIVITY_TABLE_FILTERS = "SET_USERS_ACTIVITY_TABLE_FILTERS";

export type GetUsersActivityTableFiltersState = DefaultState & {
  contents: Filters;
  exists: boolean;
};

interface SetGetUsersActivityTableFilters {
  type: typeof SET_USERS_ACTIVITY_TABLE_FILTERS;
  contents: Filters;
  exists: boolean;
}

export type GetUsersActivityTableFiltersActionTypes = SetGetUsersActivityTableFilters;
